<template>
	<div style="min-width:140px;width:40vw;max-width:200px;">

		<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
			 viewBox="0 0 400.2 181.6" style="enable-background:new 0 0 400.2 181.6;" xml:space="preserve">

			<g>
	<path d="M119.4,80.1c0-28.5-18.8-36.7-33.1-36.7c-9.7,0-19.2,3.9-27.3,9.9V2.3H27.4v6.1v2.3v6.1h16.8v100.9H27.4v6.1v2.3v6.1h48.5
		v-6.1v-2.3v-6.1H59V73c7.6-9.1,17.6-15,27.3-15c9.5,0,18.4,4.4,18.4,22.2v52.2h31.7v-6.1v-2.3v-6.1h-17V80.1z"/>
				<path d="M335.9,43.4c-27.8,0-45.4,21.7-45.4,45.4c0,24.7,19.2,45.1,47,45.1c13.1,0,26.2-5.2,36.4-13.6l-4-4.7l-1.5-1.6l-3.9-4.9
		c-8.1,6.6-16.8,10.2-27,10.2c-16.7,0-28.5-10-31.5-23.4h69C384.1,72,367.6,43.4,335.9,43.4z M335.9,57.9
		c16.3,0,26.2,11.5,26.7,23.4H306C308.9,68.3,320.1,57.9,335.9,57.9z"/>
				<polygon points="293,53.4 293,51.1 293,45 246.2,45 246.2,51.1 246.2,53.4 246.2,59.5 261,59.5 237.8,112.9 214.5,59.5 229.4,59.5
		229.4,53.4 229.4,51.1 229.4,45 182.5,45 182.5,51.1 182.5,53.4 182.5,59.5 198.6,59.5 231.1,133.7 237.7,133.7 244.4,133.7
		276.9,59.5 293,59.5 	"/>
				<polygon points="173.9,45 142.4,45 142.4,51.1 142.4,53.4 142.4,59.5 159.4,59.5 159.4,117.7 142.4,117.7 142.4,123.9 142.4,126.1
		142.4,132.3 190.9,132.3 190.9,126.1 190.9,123.9 190.9,117.7 173.9,117.7 	"/>
				<path d="M164.9,30.4c6.8,0,12.3-5.5,12.3-12.3c0-6.6-5.5-12.1-12.3-12.1c-6.6,0-12.1,5.5-12.1,12.1
		C152.7,24.9,158.2,30.4,164.9,30.4z"/>
</g>
			<g>
	<path class="st0" d="M113.3,80.1c0-23.9-14.6-30.6-27-30.6c-12.3,0-24.7,7.3-33.5,17.8V8.4H27.4v2.3h23.1v113.2H27.4v2.3h48.5v-2.3
		H52.8v-53c8.7-11.5,21-19.1,33.5-19.1c11.8,0,24.7,5.7,24.7,28.3v46.1h25.4v-2.3h-23.1V80.1z"/>
				<polygon class="st0" points="167.8,51.1 142.4,51.1 142.4,53.4 165.5,53.4 165.5,123.9 142.4,123.9 142.4,126.1 190.9,126.1
		190.9,123.9 167.8,123.9 	"/>
				<path class="st0" d="M164.9,24.4c3.6,0,6.3-2.7,6.3-6.3c0-3.4-2.7-6.1-6.3-6.1c-3.4,0-6.1,2.7-6.1,6.1
		C158.7,21.7,161.5,24.4,164.9,24.4z M164.9,14.3c2.3,0,4,1.6,4,3.9s-1.6,4-4,4c-2.1,0-3.9-1.6-3.9-4C161,16,162.6,14.3,164.9,14.3z
		"/>
				<path class="st0" d="M335.9,49.5c-23.6,0-39.1,18.9-39.1,39.3c0,21.2,16.7,39,40.7,39c11.8,0,23.1-4.4,32.3-12.1l-1.5-1.6
		c-9.1,7.4-19.4,11.5-30.9,11.5c-22.8,0-38-15.8-38.5-35.7h71.5C375.1,70.5,361.3,49.5,335.9,49.5z M368.6,87.5h-69.5
		c0.6-18.9,14.7-35.7,36.9-35.7C358.7,51.8,371.7,70.2,368.6,87.5z"/>
				<polygon class="st0" points="246.2,53.4 270.4,53.4 237.8,128.7 205.1,53.4 229.4,53.4 229.4,51.1 182.5,51.1 182.5,53.4
		202.7,53.4 237.7,133.7 272.8,53.4 293,53.4 293,51.1 246.2,51.1 	"/>
</g>
			<g>
	<path d="M113.7,164.4c3,0,4.5,1.3,4.5,3.7v1.5c0,2.3-1.5,3.6-4.5,3.6h-3.4v5.1h-2.8v-13.9H113.7z M110.3,170.9h3.1
		c1.4,0,2-0.5,2-1.7v-0.8c0-1.2-0.6-1.7-2-1.7h-3.1V170.9z"/>
				<path d="M134.6,164.4c3,0,4.5,1.2,4.5,3.5v1.4c0,1.7-0.8,2.8-2.6,3.2l3.1,5.8h-3.1l-2.6-5.4h-2.6v5.4h-2.8v-13.9H134.6z
		 M131.2,170.6h3.1c1.4,0,2-0.5,2-1.6v-0.7c0-1.2-0.6-1.7-2-1.7h-3.1V170.6z"/>
				<path d="M156.3,164.2c3.4,0,4.9,1.7,4.9,5.1v4.3c0,3.4-1.7,4.8-4.9,4.8h-1.9c-3.3,0-5-1.4-5-4.8v-4.3c0-3.3,1.5-5.1,5-5.1H156.3z
		 M154.7,166.5c-1.7,0-2.5,0.8-2.5,2.9v4.2c0,2,0.8,2.7,2.5,2.7h1.3c1.7,0,2.5-0.7,2.5-2.7v-4.2c0-2-0.7-2.9-2.5-2.9H154.7z"/>
				<path d="M177.9,164.4c3,0,4.5,1.3,4.5,3.7v1.5c0,2.3-1.5,3.6-4.5,3.6h-3.4v5.1h-2.8v-13.9H177.9z M174.6,170.9h3.1
		c1.4,0,2-0.5,2-1.7v-0.8c0-1.2-0.6-1.7-2-1.7h-3.1V170.9z"/>
				<path d="M195.5,166.7v3.4h6.4v2.2h-6.4v3.8h6.9v2.2h-9.7v-13.9h9.5v2.2H195.5z"/>
				<path d="M218.7,164.4c3,0,4.5,1.2,4.5,3.5v1.4c0,1.7-0.8,2.8-2.6,3.2l3.1,5.8h-3.1l-2.6-5.4h-2.6v5.4h-2.8v-13.9H218.7z
		 M215.3,170.6h3.1c1.4,0,2-0.5,2-1.6v-0.7c0-1.2-0.6-1.7-2-1.7h-3.1V170.6z"/>
				<path d="M239.7,166.7v11.6h-2.8v-11.6h-4.1v-2.2h11v2.2H239.7z"/>
				<path d="M253.7,178.3v-13.9h2.8v13.9H253.7z"/>
				<path d="M269.9,166.7v3.4h6.4v2.2h-6.4v3.8h6.9v2.2h-9.7v-13.9h9.5v2.2H269.9z"/>
				<path d="M286.6,167.7c0-2.1,1-3.5,5.2-3.5c4.2,0,5.2,1.2,5.2,3.4l-2.7,0.2c0-0.9-0.4-1.4-2.5-1.4c-2,0-2.4,0.5-2.4,1.4v0.7
		c0,0.9,0.6,1.1,2.9,1.3c3,0.2,5.3,0.7,5.3,3.8v1.5c0,2.4-1.7,3.4-5.7,3.4c-3.8,0-5.4-0.8-5.4-3.6l2.6-0.1c0,1,0.6,1.5,2.8,1.5
		c2.2,0,2.9-0.6,2.9-1.4v-0.7c0-1.3-0.8-1.4-3.1-1.6c-3.2-0.3-5-0.8-5-3.2V167.7z"/>
</g>
			<g>
	<path d="M395.4,44.5c0,4.1-3.4,7.5-7.5,7.5c-4.1,0-7.5-3.4-7.5-7.5s3.4-7.5,7.5-7.5C392,37,395.4,40.4,395.4,44.5z M382.1,44.5
		c0,3.3,2.6,5.9,5.8,5.9c3.1,0,5.8-2.6,5.8-5.9c0-3.3-2.6-5.9-5.8-5.9C384.7,38.6,382.1,41.2,382.1,44.5z M388.3,40.7
		c1.6,0,2.4,0.7,2.4,1.9v0.7c0,0.9-0.4,1.5-1.4,1.7l1.7,3.1h-1.8l-1.4-2.9h-1.3v2.9h-1.6v-7.5H388.3z M388.1,44c0.7,0,1-0.2,1-0.8
		v-0.4c0-0.6-0.2-0.8-1-0.8h-1.6v2H388.1z"/>
</g>
</svg>
	</div>
</template>

<script>
	export default {
		name: "LogoPrimary"
	}
</script>

<style scoped>
	.st0{fill:#BCBA8B;}
</style>